import { render, staticRenderFns } from "./MonthlyGrowthCharts.vue?vue&type=template&id=6c2972a3&lang=pug"
import script from "./MonthlyGrowthCharts.vue?vue&type=script&lang=js"
export * from "./MonthlyGrowthCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports